<div
  class="radio {{ colorClass() }}"
  [class.radio--disabled]="isDisabled()"
  [class.radio--error]="group.isInvalidShown()"
>
  <input
    [id]="id"
    [name]="group.groupName"
    [checked]="isChecked()"
    [disabled]="isDisabled()"
    type="radio"
    class="radio__input"
    hidden
    (change)="group.select(value())"
  />
  <label [for]="id" class="radio__label">
    <span class="radio__circle"></span>
    <span class="radio__label-content">
      @if (label(); as label) {
        <span>{{ label }}</span>
      }
      @if (description(); as description) {
        <span class="radio__label-description">{{ description }}</span>
      }
    </span>
  </label>
</div>
